import React, { useEffect, Fragment } from 'react';
import { Col, Button, Row, Form, message, Spin } from 'antd';
import FormGroup from 'Molecules/FormGroup';
import { useTranslate } from 'Translate';

const _ = require('lodash');

export default (props) => {
  const { id, mode, errors, control, meta, data, setValue, allowedEdit, handleSubmit, editPosUser, addPosUser, reloadApi } = props;
  const i18n = useTranslate();
  const { t } = i18n;

  const formFields = [
    {
      name: 'username',
      label: t("System.username"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit,
      nospace: true
    },
    {
      name: 'name',
      label: t("Outlet.name"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'preferred_name',
      label: t("System.nickname"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'roles',
      label: t("General.roles"),
      req: true,
      type: 'select',
      options: meta?.roles?.map((x) => ({ label: x.name, value: x.id })),
      placeholder: t("General.please_select"),
      twocol: false,
      multiple: true,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      type: 'switch',
      name: 'is_demo',
      label: t("System.demo_user"),
      req: false,
      twocol: false,
      colWidth: '0 1 100%',
      alignEnd: true
    },
    {
      type: 'switch',
      name: 'kitchen_queue_disabled',
      label: t("System.kitchen_queue_disabled"),
      req: false,
      twocol: false,
      colWidth: '0 1 100%',
      alignEnd: true
    },
  ];

  useEffect(() => {
    if (data && 'id' in data) {
      let temp = [];
      data?.roles?.map(role => {
        temp.push({
          label: role.name,
          value: role.id
        })
      })
      setValue('username', data.username);
      setValue('name', data.name);
      setValue('preferred_name', data.preferred_name);
      setValue('email', data.email);
      setValue('roles', temp);
      setValue('is_demo', data.is_demo === "1");
      setValue('kitchen_queue_disabled', data.kitchen_queue_disabled === "1");
    }
  }, [data]);

  const onFinish = async (val) => {
    props.setLoading(true);
    const payload = {
      ...val,
      roles: JSON.stringify(val.roles.map(x => ({ id: x.value }))),
      is_demo: val?.is_demo ? "1" : "0",
      kitchen_queue_disabled: val?.kitchen_queue_disabled ? "1" : "0",
      id: id
    }

    await (mode === "add" ? addPosUser : editPosUser)(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(`${mode === "add" ? t("System.pos_user_add_success") : t("System.pos_user_edit_success")}`);
        reloadApi(res.data.data);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message);
    })
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[20, 30]}>
        {formFields.map((item, idx) => (
          <Fragment key={idx}>
            <FormGroup item={item} control={control} errors={errors} />
          </Fragment>
        ))}
        {
          allowedEdit &&
          <Col span={24} className='text-right'>
            <Button size="large" htmlType='submit' className='green-btn attendance-success'>{t("General.save")}</Button>
          </Col>
        }
      </Row>
    </Form>
  )
}